import ImprovedDragAndDropList from '@COMPONENTS/SHARED/ImprovedDragAndDropList';
import classNames from 'classnames/bind';
import React from 'react';
import styles from './ImprovedRecursiveDragAndDrop.module.scss';

const cx: CX = classNames.bind(styles);

interface TreeNode {
    id: number;
    name: string;
    section?: TreeNode[];
    subSection?: TreeNode[];
    subMenu?: TreeNode[];
}

interface Props {
    treeData: TreeNode[];
    onDragEnd: (items: TreeNode[], level: string, parentId?: number) => void;
}

function ImprovedRecursiveDragAndDrop(props: Props) {
    const { treeData, onDragEnd } = props;

    const renderDragAndDrop = (
        list: TreeNode[],
        level: string,
        parentId?: number,
        hierarchyPrefix = '',
        depth = 0,
    ) => (
        <div className={cx('drag-container', `level-${depth}`)}>
            <ImprovedDragAndDropList<TreeNode>
                list={list}
                onDragEnd={(items) => onDragEnd(items, level, parentId)}
            >
                {(item, index, isDragging) => {
                    const currentIndex = `${hierarchyPrefix}${index + 1}`;
                    return (
                        <div 
                            className={cx('tree-item', `${level}-item`, {
                                'is-dragging': isDragging,
                            })}
                        >
                            <div className={cx('item-content')}>
                                <div className={cx('drag-handle')}>
                                    <svg
                                        width="16"
                                        height="16"
                                        viewBox="0 0 16 16"
                                        fill="currentColor"
                                        className={cx('drag-icon')}
                                    >
                                        <circle cx="4" cy="4" r="1.5" />
                                        <circle cx="12" cy="4" r="1.5" />
                                        <circle cx="4" cy="8" r="1.5" />
                                        <circle cx="12" cy="8" r="1.5" />
                                        <circle cx="4" cy="12" r="1.5" />
                                        <circle cx="12" cy="12" r="1.5" />
                                    </svg>
                                </div>
                                <span className={cx('item-number')}>{currentIndex}</span>
                                <span className={cx('item-name')}>{item.name}</span>
                            </div>

                            {/* Render nested sections */}
                            {item.section && item.section.length > 0 && (
                                <div className={cx('nested-container')}>
                                    {renderDragAndDrop(
                                        item.section,
                                        'section',
                                        item.id,
                                        `${currentIndex}.`,
                                        depth + 1,
                                    )}
                                </div>
                            )}

                            {/* Render nested subsections */}
                            {item.subSection && item.subSection.length > 0 && (
                                <div className={cx('nested-container')}>
                                    {renderDragAndDrop(
                                        item.subSection,
                                        'subSection',
                                        item.id,
                                        `${currentIndex}.`,
                                        depth + 1,
                                    )}
                                </div>
                            )}

                            {/* Render nested submenus */}
                            {item.subMenu && item.subMenu.length > 0 && (
                                <div className={cx('nested-container')}>
                                    {renderDragAndDrop(
                                        item.subMenu,
                                        'subMenu',
                                        item.id,
                                        `${currentIndex}.`,
                                        depth + 1,
                                    )}
                                </div>
                            )}
                        </div>
                    );
                }}
            </ImprovedDragAndDropList>
        </div>
    );

    return (
        <div className={cx('improved-recursive-container')}>
            {renderDragAndDrop(treeData, 'chapter', undefined, '', 0)}
        </div>
    );
}

export default ImprovedRecursiveDragAndDrop; 